import React, { useState } from 'react';
import NoIndex from '../../../components/NoIndex';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { FaEye } from 'react-icons/fa';
import Styles from './styles.module.css';
import inputStyles from './input.module.css';
import Icon from '../../../image/icon_black.png';

const SanpouLogin: React.FC = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordEye, setPasswordEye] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    if (email.length <= 7) { setError('メールアドレスを入力してください。'); return; }
    if (password.length <= 7) { setError('パスワードを8文字以上入力してください。'); return; }

    setLoading(true);
    try {
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const uid = credential.user.uid;

      const sanpouSnap = await getDoc(doc(db, 'info', 'sanpou'));
      const authList: string[] = sanpouSnap.data()?.auth ?? [];

      if (!authList.includes(uid)) {
        await signOut(auth);
        setError('このアカウントはアクセス権限がありません。');
        setLoading(false);
        return;
      }

      navigate('/sanpou');
    } catch (err: any) {
      setLoading(false);
      switch (err.code) {
        case 'auth/invalid-email':
          setError('メールアドレスの形式が正しくありません。');
          break;
        case 'auth/invalid-credential':
          setError('メールアドレスまたはパスワードが正しくありません。');
          break;
        case 'auth/too-many-requests':
          setError('ログイン試行が多すぎます。しばらく時間を置いてから再度お試しください。');
          break;
        default:
          setError('エラーが発生しました。担当者にご連絡ください。');
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className={Styles.container}>
      <NoIndex title="ログイン | memorii" />
      <div className={Styles.header}>
        <img className={Styles.header_logo} src={Icon} alt="memorii" />
      </div>

      <div className={Styles.card}>
        <div className={Styles.card_inner}>

          {error
            ? <p className={Styles.error}>{error}</p>
            : <div className={Styles.error_placeholder} />
          }

          {loading ? (
            <p className={Styles.loading}>処理中...</p>
          ) : (
            <>
              <h4 className={Styles.title}>ガイダンス管理ログイン</h4>

              <p className={inputStyles.input_title}>メールアドレス</p>
              <div className={inputStyles.input_input}>
                <input
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="example@mail.com"
                />
              </div>

              <p className={inputStyles.input_title}>パスワード</p>
              <div className={inputStyles.input_input}>
                <input
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                  type={passwordEye ? 'text' : 'password'}
                  placeholder="••••••••"
                />
                <FaEye
                  className={inputStyles.input_icon}
                  onClick={() => setPasswordEye(!passwordEye)}
                />
              </div>

              <button className={Styles.btn} onClick={handleLogin}>
                ログインする
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default SanpouLogin;
